module.exports = __webpack_public_path__ + "media/Audio17_q.c10cd0d6.wav";